import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    Input,
    OnInit,
    QueryList,
    ViewChildren
} from '@angular/core';

@Component({
    selector: 'da-teaser-card-box',
    templateUrl: './teaser-card-box.component.html',
    styleUrls: ['./teaser-card-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TeaserCardBoxComponent implements OnInit {
    @Input() data;
    @ViewChildren('image', { read: ElementRef }) imagesEl: QueryList<any>;
    public itemList = [];

    constructor(protected _ref: ChangeDetectorRef) {}

    get columnClasses() {
        if (this.itemList.length <= 3) {
            return 'threecolumn';
        }
    }

    ngOnInit() {
        this.data.itemList.forEach((i, n) => {
            if (!!i.headline || !!i.copytext.value || !!i.image.imageUrl || !!i.button.text) {
                this.itemList.push(i);
            }
        });
    }

    public imgLoaded(i: number) {
        this.imagesEl.forEach((img, idx) => {
            if (i === idx && this.isIE()) {
                setTimeout(() => {
                    img.nativeElement.style.height = img.nativeElement.clientHeight + 'px';
                }, 250);
            }
        });
    }

    public isIE(): boolean {
        return /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    }

    @HostListener('window:resize', ['$event'])
    resizeBy($win) {
        if (this.imagesEl && this.isIE()) {
            this.imagesEl.forEach((img) => {
                img.nativeElement.style.height = 'auto';
                img.nativeElement.style.height = img.nativeElement.clientHeight + 'px';
            });
        }
    }
}
